<template>
  <div
    id="navbar"
    :class="[$style.wrapper]"
  >
    <transition
      v-if="hasMenu"
      name="slide"
      tag="div"
      enter-active-class="fadeInDown"
      leave-active-class="fadeOutUp"
      :duration="{ enter: 500, leave: 400 }"
      mode="out-in"
    >
      <template>
        <div
          v-if="isMenuActive"
          :class="$style.mobileMenuWrapper"
        >
          <div class="d-flex justify-content-end p-2">
            <font-awesome-icon
              icon="times"
              size="2x"
              :class="$style.closeMenuIcon"
              @click="hideMobileMenu"
            />
          </div>
          <div class="d-flex flex-column align-items-center px-4 pb-2">
            <TheChangeAvatar
              v-if="user && user.avatar"
              :url="user.avatar.image_url"
              @click="handleAvatarEditClick"
            />
            <span
              :class="$style.userNameWrapper"
              class="pt-3"
            >
              {{ user.name }}
            </span>
          </div>
          <div :class="$style.menuItems">
            <router-link
              :to="{name: 'home'}"
              :class="$style.mobileItem"
              @click.native="hideMobileMenu"
            >
              <BaseButton
                variant="gray"
                alignment="left"
                size="xl"
                is-full-width
              >
                {{ $t('home') }}
              </BaseButton>
            </router-link>

            <router-link
              :to="{name: 'my-profile'}"
              :class="$style.mobileItem"
              @click.native="hideMobileMenu"
            >
              <BaseButton
                variant="gray"
                alignment="left"
                size="xl"
                is-full-width
              >
                {{ $t('my-profile') }}
              </BaseButton>
            </router-link>

            <router-link
              :to="{name: 'my-friends-page'}"
              :class="$style.mobileItem"
              @click.native="hideMobileMenu"
            >
              <BaseButton
                variant="gray"
                alignment="left"
                size="xl"
                is-full-width
              >
                {{ $t('my-friends') }}
              </BaseButton>
            </router-link>

            <a
              :class="$style.mobileItem"
              @click="handleHowToPlayClick"
            >
              <BaseButton
                variant="gray"
                alignment="left"
                size="xl"
                is-full-width
              >
                {{ $t('how-to-play') }}
              </BaseButton>
            </a>

            <router-link
              :to="{name: 'prizes'}"
              :class="$style.mobileItem"
              @click.native="hideMobileMenu"
            >
              <BaseButton
                variant="gray"
                alignment="left"
                size="xl"
                is-full-width
              >
                {{ $t('prizes') }}
              </BaseButton>
            </router-link>

            <router-link
              :to="{name: 'current-round-standings'}"
              :class="$style.mobileItem"
              @click.native="hideMobileMenu"
            >
              <BaseButton
                variant="gray"
                alignment="left"
                size="xl"
                is-full-width
              >
                {{ $t('standings') }}
              </BaseButton>
            </router-link>

            <router-link
              :to="{name: 'rules'}"
              :class="$style.mobileItem"
              @click.native="hideMobileMenu"
            >
              <BaseButton
                variant="gray"
                alignment="left"
                size="xl"
                is-full-width
              >
                {{ $t('rules') }}
              </BaseButton>
            </router-link>

            <router-link
              :to="{name: 'terms-and-conditions'}"
              :class="$style.mobileItem"
              @click.native="hideMobileMenu"
            >
              <BaseButton
                variant="gray"
                alignment="left"
                size="xl"
                is-full-width
              >
                {{ $t('terms-and-conditions') }}
              </BaseButton>
            </router-link>

            <router-link
              :to="{name: 'logout'}"
              :class="$style.mobileItem"
              @click.native="hideMobileMenu"
            >
              <BaseButton
                variant="gray"
                alignment="left"
                size="xl"
                font-size="xlarge"
                is-full-width
              >
                {{ $t('logout') }}
              </BaseButton>
            </router-link>
          </div>
        </div>
      </template>
    </transition>
    <b-row class="p-1">
      <b-col class="d-flex align-items-center">
        <span class="ml-2">
          <a
            v-if="isBackArrowEnabled"
            :class="$style.backArrow"
            @click="$router.back()"
          >
            <font-awesome-icon
              icon="arrow-left"
              size="2x"
            />
          </a>
          <span
            v-else-if="!isGameSwitcherHidden"
          >
            <TheGameTypeSwitcher />
          </span>
        </span>
      </b-col>
      <b-col>
        <div
          v-if="hasSmallLogo"
          class="text-center"
          :class="$style.smallLogoWrapper"
        >
          <router-link :to="{name: 'home'}">
            <img
              v-if="!smallLogoPath"
              :src="require(`@/assets/images/logo-white-${this.$i18n.locale}.svg`)"
              :class="$style.logo"
            >
            <img
              v-else
              :src="require(`@/assets/images/${smallLogoPath}`)"
              :class="$style.logo"
            >
          </router-link>
        </div>
      </b-col>
      <b-col class="d-flex align-items-center justify-content-end">
        <TheLanguageSwitcher @onLanguageChange="handleLanguageChange" />
        <font-awesome-icon
          v-if="hasMenu"
          :class="$style.menuButton"
          size="2x"
          icon="bars"
          @click="isMenuActive = true"
        />
      </b-col>
    </b-row>
    <div
      v-if="hasBigLogo"
      class="text-center"
      :class="$style.bigLogoWrapper"
    >
      <router-link :to="{name: 'home'}">
        <img
          :src="require(`@/assets/images/logo-white-${$i18n.locale}.svg`)"
          :class="$style.logo"
        >
      </router-link>
    </div>
    <span
      v-if="title"
      :class="$style.title"
    >
      {{ $t(title) }}
    </span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TheLanguageSwitcher from '@/components/Molecules/TheLanguageSwitcher'
import BaseButton from '@/components/Atoms/BaseButton'
import TheChangeAvatar from '@/components/Molecules/TheChangeAvatar'
import TheGameTypeSwitcher from '@/components/Molecules/TheGameTypeSwitcher'

export default {
  name: 'MainNavbar',
  components: {
    TheGameTypeSwitcher,
    TheChangeAvatar,
    BaseButton,
    TheLanguageSwitcher,
  },
  props: {
    isBackArrowEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    hasBigLogo: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasSmallLogo: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasMenu: {
      type: Boolean,
      required: false,
      default: true,
    },
    isGameSwitcherHidden: {
      type: Boolean,
      required: false,
      default: false,
    },
    smallLogoPath: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isMenuActive: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  methods: {
    ...mapActions({
      openHowToPlayModal: 'profile/howToPlay/openHowToPlayModal',
    }),
    hideMobileMenu() {
      this.isMenuActive = false
    },
    handleLanguageChange({ locale }) {
      this.$emit('onLanguageSwitch', { locale })
    },
    handleHowToPlayClick() {
      this.hideMobileMenu()
      this.openHowToPlayModal({
        isFirstSlideSkipped: true,
      })
    },
    handleAvatarEditClick() {
      this.hideMobileMenu()
      this.$router.push({
        name: 'change-avatar',
      })
    },
  },
}
</script>

<style lang="scss" module>
  @import "../assets/scss/variables";
  .wrapper {
    min-width: 100vw;
    color: $color-white;
    background-color: $color-midnight-blue;
    &.fixed {
      position: fixed;
      top: 0;
      z-index: 10;
      width: 100vw;
    }
    .backArrow {
      color: $color-white;
      cursor: pointer;
    }
    .bigLogoWrapper {
      height: 50px;
      margin-bottom: .5rem;
      .logo {
        max-height: 50px;
      }
    }
    .smallLogoWrapper {
      height: 40px;
      .logo {
        height: 40px;
        width: auto;
      }
    }
    .title {
      display: flex;
      font-size: $font-size-xlarge;
      font-weight: 600;
      justify-content: center;
      padding-bottom: .5rem;
    }

    .menuButton {
      cursor: pointer;
      margin: 0 .5rem;
    }
  }

  .mobileMenuWrapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    width: 100vw;
    height: 100vh;
    background-color: $color-midnight-blue;
    overflow: auto;

    .closeMenuIcon {
      color: $color-white;
      cursor: pointer;
    }

    .userNameWrapper {
      font-size: $font-size-xlarge;
    }
    .menuItems {
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 100%;
      background-color: $color-white;
    }
    .mobileItem {
      border-bottom: 1px solid $color-white;
    }
  }
</style>
